import PhotoProductPanel from "./photoProductPanel.container";

export default PhotoProductPanel;
